/** Standard chart grid with generous left margin for formatted labels. */
export const defaultGrid = { left: 72, right: 24, top: 30, bottom: 40 } as const;

/** Fallback axis label formatter — prevents ECharts from showing ugly long decimals. */
export function defaultAxisLabel(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1e9) return `${(value / 1e9).toPrecision(3)}b`;
  if (abs >= 1e6) return `${(value / 1e6).toPrecision(3)}m`;
  if (abs >= 1e3) return `${(value / 1e3).toPrecision(3)}k`;
  if (abs === 0) return "0";
  if (abs < 0.01) return value.toPrecision(2);
  if (abs < 1) return value.toPrecision(3);
  return value.toPrecision(4);
}

/** Tooltip CSS — DS dark snackbar: black bg, white text, soft shadow. */
export const tooltipCss = [
  "background: #1D1D1F",
  "border: none",
  "border-radius: 4px",
  "box-shadow: 0 2px 8px rgba(0,0,0,0.08)",
  "font-family: 'GT America Regular', Helvetica, Arial, sans-serif",
  "font-size: 11px",
  "color: #FFFFFF",
  "padding: 10px 12px",
].join(";");
